// extracted by mini-css-extract-plugin
module.exports = {"option":"Book_option__3Wu0A","avatar":"Book_avatar__3dr-t","book":"Book_book__WAW0g","title":"Book_title__1dYSf","bookInfo":"Book_bookInfo__1GPoA","buttons":"Book_buttons__hjsH4"};